import {
  selectSubscriptionProviderName,
  selectSubscriptionStatus,
} from '../../selectors/me';
import { premiumSubscriptionStatus } from './subscriptionStatus';
import subscribedThroughWeb from './subscribedThroughWeb';

export default function hasNeverSubscribedOnWeb(me) {
  const meStatus = selectSubscriptionStatus({ me });
  const meProvider = selectSubscriptionProviderName({ me });

  if (!meStatus) {
    return true; // assumes no user means no subscription
  }

  const hasNoStatus = meStatus === premiumSubscriptionStatus.none;
  const hasExpiredStatus = meStatus === premiumSubscriptionStatus.expired;

  // users who have expired subscriptions from other providers (apple etc),
  // can subscribe on web and get a free trial
  return hasNoStatus || (hasExpiredStatus && !subscribedThroughWeb(meProvider));
}
